import { render } from "./QuoteLoader.vue?vue&type=template&id=5bf9b7d0"
import script from "./QuoteLoader.vue?vue&type=script&lang=js"
export * from "./QuoteLoader.vue?vue&type=script&lang=js"

import "./QuoteLoader.vue?vue&type=style&index=0&id=5bf9b7d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__